/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import DialogScrollContainer from '@shared/components/DialogScrollContainer';
import { enableImmunizations } from '@/app/services/immunizations/Immunization';
import * as Actions from '@/app/store/actions';
import { CircularProgress } from '@material-ui/core';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

const ImmunizationListDialog = ({ rows, enabled, studentId, refresh, setRefresh }) => {
	const dispatch = useDispatch();
	const [sending, setSending] = useState(false);
	const [activeImm, setActiveImm] = useState(enabled.filter((imm) => imm.is_enabled).map((imm) => imm.immunization_id));

	const handleEnableDisable = (id) => {
		if (activeImm.indexOf(id) === -1) {
			setActiveImm([...activeImm, id]);
		} else {
			setActiveImm([...activeImm.slice(0, activeImm.indexOf(id)), ...activeImm.slice(activeImm.indexOf(id) + 1)]);
		}
	};

	const handleSubmit = () => {
		setSending(true);
		enableImmunizations({ student_id: studentId, immunization_id: activeImm })
			.then(() => {
				setRefresh(refresh + 1);

				dispatch(Actions.closeDialog());
			})
			.catch(() => {
				setSending(false);
				dispatch(
					Actions.showMessage({
						message: 'Please select atleast one immunization.',
					}),
				);
			});
	};

	return (
		<div className="bg-white px-32 min-h-[450px] max-h-[480px] pt-[10px] min-[400px]:min-w-[370px] min-[500px]:min-w-[440px]">
			<div className="flex justify-between align-top py-[10px] px-0 content-center items-center mx-auto font-bold w-[90%]">
				<div>
					<h1 className="mb-0" style={{ fontSize: '20px', fontWweight: '700' }}>
						Immunization Settings
					</h1>
					<p style={{ fontSize: '12px', color: '#818181', fontWeight: '300' }}>
						Which immunization should appear on reports and student records?
					</p>
				</div>
				<div>
					<i
						className="fas text-[20px]"
						onClick={() => dispatch(Actions.closeDialog())}
						style={{ cursor: 'pointer' }}
					/>
				</div>
			</div>
			<DialogScrollContainer id="scrollable-list">
				{rows?.map((immu, i, arr) => {
					return (
						<div
							key={immu.id}
							style={{
								cursor: 'pointer',
							}}
						>
							<div
								className="p-16 flex justify-between items-center"
								onClick={() => handleEnableDisable(immu.id)}
								style={{ gap: 10 }}
							>
								<div>{immu.name.split('-')[0]}</div>
								<div
									className="rounded-full flex justify-center items-center p-4 text-white border-[1px] border-[#4DA0EE] w-[24px] h-[24px]"
									style={{
										background: activeImm.includes(immu.id) ? '#4DA0EE' : 'white',
									}}
								>
									<i className="fas fa-check" />
								</div>
							</div>
							{i !== arr.length - 1 ? <hr style={{ borderColor: 'lightgray' }} /> : null}
						</div>
					);
				})}
			</DialogScrollContainer>
			<div className="w-full flex justify-center">
				{sending ? (
					<div className="w-1/12 mx-auto mt-24">
						<CircularProgress size={35} />
					</div>
				) : (
					<div className="flex mt-24" style={{ gap: '10px' }}>
						<CustomButton onClick={() => dispatch(Actions.closeDialog())} variant="secondary">
							Cancel
						</CustomButton>
						<CustomButton onClick={handleSubmit} variant="primary">
							Apply
						</CustomButton>
					</div>
				)}
			</div>
		</div>
	);
};

export default ImmunizationListDialog;
